import type { PanderrTemplateDefinition } from "./types";

import { PROFESSIONAL_MODERN_TEMPLATE } from "./templates/professional-modern";

import { LOCAL_SERVICE_TEMPLATE } from "./templates/local-service";

import { CONTRACTOR_MODERN_TEMPLATE } from "./templates/contractor-modern";

import { MUNICIPALITY_MODERN_TEMPLATE } from "./templates/municipality-modern";

import { HOSPITALITY_MODERN_TEMPLATE } from "./templates/hospitality-modern";

import { WELLNESS_MODERN_TEMPLATE } from "./templates/wellness-modern";

import { AUTHOR_PORTFOLIO_MODERN_TEMPLATE } from "./templates/author-portfolio-modern";

import { POOL_SERVICE_MODERN_TEMPLATE } from "./templates/pool-service-modern";

export interface PanderrTemplateRegistryItem {
  id: string;
  name: string;
  category: string;
  description: string;
  template: PanderrTemplateDefinition;
  previewImage: string;
}

export const PANDERR_TEMPLATE_REGISTRY: PanderrTemplateRegistryItem[] = [
  {
    id: PROFESSIONAL_MODERN_TEMPLATE.id,
    name: PROFESSIONAL_MODERN_TEMPLATE.name,
    category: "Professional",
    description:
      "Clean, polished, and flexible for professional services, consultants, agencies, and growing companies.",
    template: PROFESSIONAL_MODERN_TEMPLATE,
    previewImage:
      "/studio/assets/stock/images/nastuh-abootalebi-eHD8Y1Znfpk-unsplash.jpg",
  },

  {
    id: LOCAL_SERVICE_TEMPLATE.id,
    name: LOCAL_SERVICE_TEMPLATE.name,
    category: "Local Service",
    description:
      "A strong lead-generation design for contractors, home services, and local businesses.",
    template: LOCAL_SERVICE_TEMPLATE,
    previewImage:
      "/studio/assets/stock/images/troy-allen-bLue0yFJD08-unsplash.jpg",
  },

  {
    id: POOL_SERVICE_MODERN_TEMPLATE.id,
    name: POOL_SERVICE_MODERN_TEMPLATE.name,
    category: "Pool & Outdoor",
    description:
      "An image-forward website for pool cleaning, maintenance, repairs, renovations, and commercial pool service companies.",
    template: POOL_SERVICE_MODERN_TEMPLATE,
    previewImage: "/studio/assets/stock/images/luxury-home-pool.jpg",
  },

  {
    id: CONTRACTOR_MODERN_TEMPLATE.id,
    name: CONTRACTOR_MODERN_TEMPLATE.name,
    category: "Contractor",
    description:
      "A bold, project-focused website for contractors, builders, remodelers, and construction companies.",
    template: CONTRACTOR_MODERN_TEMPLATE,
    previewImage:
      "/studio/assets/stock/images/scott-blake-x-ghf9LjrVg-unsplash.jpg",
  },

  {
    id: MUNICIPALITY_MODERN_TEMPLATE.id,
    name: MUNICIPALITY_MODERN_TEMPLATE.name,
    category: "Government",
    description:
      "An accessible, information-first civic website for cities, towns, and local government.",
    template: MUNICIPALITY_MODERN_TEMPLATE,
    previewImage:
      "/studio/assets/stock/images/Commercial RE meeting with view of city.jpg",
  },

  {
    id: HOSPITALITY_MODERN_TEMPLATE.id,
    name: HOSPITALITY_MODERN_TEMPLATE.name,
    category: "Hospitality",
    description:
      "An image-forward website for vacation rentals, boutique stays, inns, lodges, cabins, and hospitality businesses.",
    template: HOSPITALITY_MODERN_TEMPLATE,
    previewImage:
      "/studio/assets/stock/images/spacejoy-9M66C_w_ToM-unsplash.jpg",
  },

  {
    id: WELLNESS_MODERN_TEMPLATE.id,
    name: WELLNESS_MODERN_TEMPLATE.name,
    category: "Wellness",
    description:
      "A calm, polished website for spas, salons, wellness studios, skincare, massage, and boutique wellness businesses.",
    template: WELLNESS_MODERN_TEMPLATE,
    previewImage:
      "/studio/assets/stock/images/minh-pham-OtXADkUh3-I-unsplash.jpg",
  },

  {
    id: AUTHOR_PORTFOLIO_MODERN_TEMPLATE.id,
    name: AUTHOR_PORTFOLIO_MODERN_TEMPLATE.name,
    category: "Portfolio",
    description:
      "A polished personal-brand website for authors, speakers, consultants, creatives, and individual professionals.",
    template: AUTHOR_PORTFOLIO_MODERN_TEMPLATE,
    previewImage:
      "/studio/assets/stock/images/woman working on laptop and coffee.jpeg",
  },
];

export function getPanderrTemplate(
  id: string,
): PanderrTemplateDefinition | undefined {
  return PANDERR_TEMPLATE_REGISTRY.find((item) => item.id === id)?.template;
}
